import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function useBans(userId, filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchBans() {
      setLoading(true);

      const { response, data } = await API.fetchBans(token, userId, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
      }

      setLoading(false);
    }

    if (userId) {
      fetchBans();
    }
  }, [userId, Object.values(filters).join("__")]);

  return {
    loading,
    bans: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
